import { Tooltip } from 'react-tooltip';
import { useTema } from '@/shared/state/TemaContext';
import { IconMoon, IconSun } from '@/shared/ui/Icon';

/**
 * Botão de ícone que alterna entre tema claro e escuro. Mostra a lua quando
 * está claro (clique → escuro) e o sol quando está escuro (clique → claro).
 *
 * Usa um Tooltip PRÓPRIO posicionado embaixo (`place="bottom"`): o botão fica
 * no topo da janela, então o tooltip global `icon-tip` (place="top") apareceria
 * cortado pela borda superior. Conteúdo explícito via `data-tooltip-content`
 * (não depende do `render` global que lê aria-label).
 */
export function BotaoTema() {
  const { tema, alternar } = useTema();
  const escuro = tema === 'escuro';
  const titulo = escuro ? 'Tema claro' : 'Tema escuro';

  return (
    <>
      <button
        type="button"
        className="btn btn--icon"
        onClick={alternar}
        aria-label={titulo}
        aria-pressed={escuro}
        data-tooltip-id="tema-tip"
        data-tooltip-content={titulo}
      >
        {escuro ? <IconSun width={18} height={18} /> : <IconMoon width={18} height={18} />}
      </button>
      <Tooltip id="tema-tip" place="bottom" className="app-tooltip" />
    </>
  );
}
